import { message } from "antd"
import { baseRequest } from "../../util/Api"
import { v4 } from "uuid";

export const getRooms = (trainingId, participantId = 0) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/rooms", { training_id: trainingId, participant_id: participantId })
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const getRoomsGuest = (trainingId, participantId = 0) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/rooms/guest", { training_id: trainingId, participant_id: participantId })
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const getRoomsByDates = (start, end) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/rooms", { start: start, end: end })
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const getReservations = (filter) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/rooms/reservations", filter)
      .then(data => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const getRoomsDetail = (token) => {
  return new Promise((resolve, reject) => {
    baseRequest("post", "/rooms/detail", null, { token: token })
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
        reject(e)
      })
  })
}

export const getRoomsDetailCalendar = (filter) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/rooms/detail-calendar", filter)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
        reject(e)
      })
  })
}

export const roomsSignin = (password) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Memproses login ..." })
    baseRequest("post", "/rooms/signin", null, { password: password })
      .then((data) => {
        message.success({ key, type: 'success', content: "Login berhasil" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
      })
  })
}

export const roomsBook = (data) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Memproses reservasi ..." })
    baseRequest("post", "/rooms", null, data)
      .then((data) => {
        message.success({ key, type: 'success', content: "Reservasi berhasil disimpan" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
        reject(e)
      })
  })
}

export const roomsDelete = (id) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menghapus reservasi ..." })
    baseRequest("delete", "/rooms/" + id, null)
      .then((data) => {
        message.success({ key, type: 'success', content: "Reservasi berhasil dihapus" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
      })
  })
}

